export const DEFAULT_TIME_RANGE = '7d';
